import { useEffect } from "react";
import type { Dispatch } from "react";
import { toast } from "sonner";

export const useResumeSetup = (
  setupPhase: string,
  connected: boolean,
  dispatch: Dispatch<any>
) => {
  useEffect(() => {
    if (setupPhase !== "conversation" || connected) return;

    const resumedDataStr = sessionStorage.getItem("resumedSetupData");
    if (!resumedDataStr) return;

    try {
      const { conversationId, transcript, analysis } = JSON.parse(resumedDataStr);

      if (analysis) {
        dispatch({ type: "SET_CONVERSATION_ID", payload: conversationId });
        dispatch({ type: "SET_MESSAGES", payload: transcript });
        dispatch({ type: "SET_ANALYSIS_RESULT", payload: analysis });
        dispatch({ type: "SET_PHASE", payload: "confirmation" });

        toast.success("Setup resumed successfully!", {
          description: "Review and customize your genie below.",
        });
      }
    } catch (error) {
      console.error("Failed to load resumed setup:", error);
      toast.error("Failed to load your saved setup. Please try again.");
    } finally {
      sessionStorage.removeItem("resumedSetupData");
    }
  }, [setupPhase, connected, dispatch]);

};
